import { SWRFetcher } from '@commenda/utils';
import useSWR from 'swr';

import {
  IServiceAuditorListResponse,
  IUseServiceAuditsForStepOptions,
  IUseServiceAuditsForStepParams,
  ServiceAuditorDisplayStatus,
} from './types';

const ACTIVE_AUDIT_REFRESH_INTERVAL_MS = 5000;

export function useServiceAuditsForStep(
  {
    workflowExecutionId,
    stepId,
    enabled,
  }: Readonly<IUseServiceAuditsForStepParams>,
  { refreshIntervalMs }: Readonly<IUseServiceAuditsForStepOptions>
) {
  const key =
    enabled && workflowExecutionId && stepId
      ? `agent-platform/service-auditor/workflow-executions/${encodeURIComponent(workflowExecutionId)}/steps/${encodeURIComponent(stepId)}/audits`
      : null;

  const { data, error, isLoading, mutate } =
    useSWR<IServiceAuditorListResponse>(key, SWRFetcher({ method: 'GET' }), {
      refreshInterval: (latest) => {
        const newestStatus = latest?.audits[0]?.displayStatus;
        const isNewestAuditActive =
          newestStatus === ServiceAuditorDisplayStatus.QUEUED ||
          newestStatus === ServiceAuditorDisplayStatus.RUNNING;
        return isNewestAuditActive
          ? ACTIVE_AUDIT_REFRESH_INTERVAL_MS
          : refreshIntervalMs;
      },
    });

  return {
    // Newest first, as the backend orders them.
    audits: data?.audits ?? [],
    isLoading,
    error,
    mutate,
  };
}
